import type { FC } from "react";
import { CoreCarsComponent, useCarsStyles } from "@apac/cars";
import type { CarReservationConfirmationProps } from "@apac/components/cars";
import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import defaultStyles from "./CarReservationConfirmation.module.scss";
import { getCarConfirmationCode } from "@/utilities/cars";
import { useGetTravelerType } from "~core-traveler/utilities";

export const CarReservationConfirmation: FC<
  CarReservationConfirmationProps
> = ({ reservation }) => {
  const styles = useCarsStyles(
    CoreCarsComponent.CarReservationConfirmation,
    defaultStyles
  );
  const { t } = useI18nContext();
  const [block, cn] = useModuleBEM(
    styles,
    CoreCarsComponent.CarReservationConfirmation
  );

  const getTravelerType = useGetTravelerType();

  return (
    <div className={block}>
      <h2 className={cn("title")}>{t("trips.bookingDetails")}</h2>

      {/* Field label/value pairs (not sectioning landmarks) — plain divs match the
          field/label/value pattern used by the other booking-details components and
          avoid unnamed <section> elements. */}
      <div className={cn("booking-summary-section")}>
        <div className={cn("booking-summary-section-title")}>
          {t("tripSearch.confirmationCode")}
        </div>
        <p className={cn("booking-summary-section-info")}>
          {getCarConfirmationCode(reservation)}
        </p>
      </div>

      <div className={cn("booking-summary-section")}>
        <div className={cn("booking-summary-section-title")}>
          {t("trips.cars.driver")}
        </div>
        <p className={cn("booking-summary-section-info")}>
          {reservation.driverInfo.givenName} {reservation.driverInfo.surname} -{" "}
          {getTravelerType(reservation.driverInfo.dateOfBirth)}
        </p>
      </div>

      <div className={cn("booking-summary-section")}>
        <div className={cn("booking-summary-section-title")}>
          {t("contactInformation")}
        </div>
        <p className={cn("booking-summary-section-info")}>
          {reservation.driverInfo?.phoneNumber}
        </p>
        {(reservation.driverInfo.emailAddress?.length ?? 0) > 0 && (
          <p className={cn("booking-summary-section-info")}>
            {reservation.driverInfo.emailAddress}
          </p>
        )}
      </div>

      {/* TODO(RBC-988) conditionally display extras section */}
      {/* <section className={cn("booking-summary-section")}>
        <h3 className={cn("booking-summary-section-title")}>
          {t("trips.extras")}
        </h3>
        <p className={cn("booking-summary-section-info")}>...</p>
      </section> */}
    </div>
  );
};
